import { Component, OnInit, Inject, EventEmitter } from '@angular/core';
import { AutoPanelCreationService } from 'src/app/shared/auto-panelCreation/auto-panel-creation.service';
import { AutoPanelCreation } from 'src/app/model/auto-panelCreation-module/auto-panel-creation';
import { NotificationService } from 'src/app/shared/notification.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PanelService } from 'src/app/shared/panel-service/panel.service';
import { GlobalConstantsService } from 'src/app/shared/global-constants.service';

export interface DialogData {
  processId: number;
  noOfPanels: number;
}


@Component({
  selector: 'app-auto-panel-creation',
  templateUrl: './auto-panel-creation.component.html',
  styleUrls: ['./auto-panel-creation.component.scss']
})
export class AutoPanelCreationComponent implements OnInit {

  autoPanelCreator = new EventEmitter();
  
  noOfPanels: number;
  process="";
  cards= [];

  processId: number;
  totalAvailableCandidate:number;
  totalAvailablePanelMember:number;
  meetingLinkProvider: string = null;


  constructor(public service: AutoPanelCreationService,
    private notificationService: NotificationService,
    private panelService:PanelService,
    public dialogRef: MatDialogRef<AutoPanelCreationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {
      this.processId = data.processId;
      this.meetingLinkProvider = GlobalConstantsService.meetingLinkProviderEnum['MOVIE'];
  }

  ngOnInit() {
    this.getAvailableCandidates();
    this.getAvailablePanelMember();
  }

  toggleMeetingLinkAttachment() {
    this.meetingLinkProvider = this.meetingLinkProvider === null
                                ? GlobalConstantsService.meetingLinkProviderEnum['MOVIE']
                                : null;
  }

  onSubmit() {
    if (this.service.form.valid) {
      let panelCnt = this.service.form.value.panelCnt;
      let panelMemberCntPerPanel = this.service.form.value.panelMemberCntPerPanel;
      let candidateCntPerPanel = this.service.form.value.candidateCntPerPanel;
      const meetingService = this.meetingLinkProvider;
      let autoPanelCreation = new AutoPanelCreation(panelCnt, panelMemberCntPerPanel, candidateCntPerPanel, meetingService);
      if(this.totalAvailableCandidate < panelCnt*candidateCntPerPanel){
        this.notificationService.warn("Entered panel count * per panel candidate should not more than short listed candidate!!");
        return;
      }
      if(this.totalAvailablePanelMember < panelCnt*panelMemberCntPerPanel){
        this.notificationService.warn("Entered panel count * per panel member should not more than available panel member!!");
        return;
      }
      this.service.autoPanelCreation(autoPanelCreation, this.processId)
        .then(
          newPanel => {
            this.autoPanelCreator.emit(true);
            this.notificationService.success('Successfully created');
            this.onClose();
            window.location.reload();
          },
          err => {
            console.log(err);
        });
    }
  }

  onClose() {
    this.service.form.reset();
    this.dialogRef.close();
  }
  onClear() {
    this.service.form.reset();
    this.notificationService.success('Cleared');
  }

  getAvailableCandidates() {
    this.panelService.availableCandidate(this.processId).then(
      candidates => {
        this.totalAvailableCandidate = candidates.length;
      },
      err => {
        console.log(err);
      }
    );
  }

  getAvailablePanelMember() {
    this.panelService.availablePanelMember(this.processId).then(
      panelMember => {
        this.totalAvailablePanelMember = panelMember.length;
      },
      err => {
        console.log(err);
      }
    );
  }
}